// Redux Resources
import { createResourceActions } from "src/redux_resources_v1";
import { resourceNames } from "src/constants";

export const payersResourceActions = createResourceActions(
  resourceNames.payers
);
